<script setup>
import { usePersonalAccountDataState } from '../../../utilities/account/useAccountDataPersonal'
import { formatCountry, formatDate } from '../../../utilities/helpers'
import { BriefcaseIcon, UserIcon } from '@heroicons/vue/outline'
import BaseCard from '../../base/BaseCard.vue'
import BaseButtonMuted from '../../base/BaseButtonMuted.vue'
import { switchToLegalProfile } from '../../../utilities/investment-process/useUserProfileType'
import { storeToRefs } from 'pinia'
import { useInvestmentProcessNavigation } from '../../../utilities/account/useInvestmentProcessNavigation'
import { computed } from 'vue'

const { hasLegalProfile, legalProfileKyc } = storeToRefs(usePersonalAccountDataState())
const { pageKey } = storeToRefs(useInvestmentProcessNavigation())
// const external_kyc_id_now = computed(() => window.external_kyc_id_now) - deprecated
const external_kyc = computed(() => window.external_kyc)
</script>

<template>
    <BaseCard class="overflow-hidden">
        <div class="flex items-center space-x-3 border-b border-solid border-gray-300 px-4 py-3">
            <div class="flex items-center justify-center rounded-full border-2 border-gray-300 bg-white p-1.5">
                <UserIcon class="border-gray-150 w-5" />
            </div>
            <h3 class="text-base font-semibold leading-6 text-gray-700">
                {{
                    usePersonalAccountDataState().naturalProfile.first_name +
                    ' ' +
                    usePersonalAccountDataState().naturalProfile.last_name
                }}
            </h3>
        </div>
        <div class="">
            <p class="flex justify-between border-b border-gray-200 px-4 py-2 text-sm text-gray-600 odd:bg-gray-50">
                <span class="font-semibold">{{ $t('account.date_of_birth') }}</span>
                <span class="text-right">{{
                    formatDate(usePersonalAccountDataState().naturalProfile.date_of_birth)
                }}</span>
            </p>
            <p class="flex justify-between border-b border-gray-200 px-4 py-2 text-sm text-gray-600 odd:bg-gray-50">
                <span class="font-semibold">{{ $t('account.nationality') }}</span>
                <span class="text-right">{{
                    formatCountry(usePersonalAccountDataState().naturalProfile.nationality)
                }}</span>
            </p>
            <p class="flex justify-between px-4 py-2 text-sm text-gray-600 odd:bg-gray-100">
                <span class="font-semibold">{{ $t('account.address') }}</span>
                <span class="text-right">{{ usePersonalAccountDataState().naturalProfile.address }}</span>
            </p>
        </div>
        <div
            v-if="hasLegalProfile && pageKey !== 'payment' && (!external_kyc || (legalProfileKyc && external_kyc))"
            class="flex justify-center border-t border-gray-300 p-3">
            <BaseButtonMuted class="w-full font-semibold" :icon="BriefcaseIcon" @click="switchToLegalProfile">
                {{ $t('investment_process.invest_as_legal_profile') }}
            </BaseButtonMuted>
        </div>
    </BaseCard>
</template>

<style scoped></style>
